import { ComponentType } from 'react'

import Eye from 'src/Assets/Svg/common/Eye.svg?react'
import VideoCameraIcon from 'src/Assets/Svg/common/video-camera.svg?react'
import { kFormatter } from 'src/Constants/functions'
import { TikTokCampaignPricingModelEnum } from 'src/Types/campaigns'

export type CampaignGoalConfig = {
  metricLabel: string
  icon: ComponentType
  subtitle: string
  badgeLabel: string
  hint?: string
}

export const getCampaignGoalConfig = (
  pricingModel: TikTokCampaignPricingModelEnum,
): CampaignGoalConfig => {
  if (pricingModel === TikTokCampaignPricingModelEnum.VideosBased) {
    return {
      metricLabel: 'videos',
      icon: VideoCameraIcon,
      subtitle: 'Get more creators to use your sound',
      badgeLabel: 'Videos-oriented',
      hint: 'Videos with a "Rejected" status are excluded from the campaign results and are not charged.',
    }
  }

  return {
    metricLabel: 'views',
    icon: Eye,
    subtitle: 'Get more video views',
    badgeLabel: 'Views-oriented',
  }
}

export const clampPercentage = (value: number): number =>
  Math.min(Math.max(value, 0), 100)

export const formatGoalValue = (value?: number): string | number =>
  kFormatter(value ?? 0)
